/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-Optimizer
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const LotType = {
    OPEN: 'open',
    CLOSED: 'closed'
} as const;
export type LotType = typeof LotType[keyof typeof LotType];


export function instanceOfLotType(value: any): boolean {
    for (const key in LotType) {
        if (Object.prototype.hasOwnProperty.call(LotType, key)) {
            if (LotType[key as keyof typeof LotType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function LotTypeFromJSON(json: any): LotType {
    return LotTypeFromJSONTyped(json, false);
}

export function LotTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): LotType {
    return json as LotType;
}

export function LotTypeToJSON(value?: LotType | null): any {
    return value as any;
}

export function LotTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): LotType {
    return value as LotType;
}

